"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.HTML_TYPES = exports.STYLES = exports.COLORS = exports.SIZES = void 0;
const _ui_1 = require("@ui");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./style.scss");
var SIZES;
(function (SIZES) {
    SIZES["SMALL"] = "SMALL";
    SIZES["MEDIUM"] = "MEDIUM";
    SIZES["LARGE"] = "LARGE";
    SIZES["EXTRA"] = "EXTRA";
    SIZES["FULL"] = "FULL";
})(SIZES || (exports.SIZES = SIZES = {}));
var COLORS;
(function (COLORS) {
    COLORS["PRIMARY"] = "PRIMARY";
    COLORS["RED"] = "RED";
    COLORS["GREEN"] = "GREEN";
    COLORS["WHITE"] = "WHITE";
    COLORS["ORANGE"] = "ORANGE";
    COLORS["DEFAULT"] = "DEFAULT";
    COLORS["DARK_BLUE"] = "DARK_BLUE";
})(COLORS || (exports.COLORS = COLORS = {}));
var STYLES;
(function (STYLES) {
    STYLES["CONTAINED"] = "CONTAINED";
    STYLES["OUTLINED"] = "OUTLINED";
    STYLES["LIGHT"] = "LIGHT";
    STYLES["BORDERLESS"] = "BORDERLESS";
    STYLES["UNDERLINED"] = "UNDERLINED";
})(STYLES || (exports.STYLES = STYLES = {}));
var HTML_TYPES;
(function (HTML_TYPES) {
    HTML_TYPES["BUTTON"] = "BUTTON";
    HTML_TYPES["SUBMIT"] = "SUBMIT";
})(HTML_TYPES || (exports.HTML_TYPES = HTML_TYPES = {}));
const Button = ({ size = SIZES.MEDIUM, htmlType = HTML_TYPES.BUTTON, style = STYLES.OUTLINED, color = COLORS.PRIMARY, tabIndex = 1, disabled = false, onClickActiveWhenDisabled = false, loading = false, label = '', onClick, children, ico, bold, onContextMenu, testid, dataTour, }) => {
    return (react_1.default.createElement("button", { tabIndex: tabIndex, "data-testid": testid, "data-tour": dataTour, onClick: (!disabled || onClickActiveWhenDisabled) && !loading ? onClick : undefined, onContextMenu: onContextMenu, type: htmlType === HTML_TYPES.SUBMIT ? 'submit' : 'button', className: (0, classnames_1.default)('ds-button', size?.toLowerCase(), style?.toLowerCase(), color?.toLowerCase(), {
            'with-ico': ico ?? loading,
            'only-ico': !label && !children,
            bold,
            disabled,
            loading,
        }) },
        !loading && ico && (react_1.default.createElement("div", { className: 'icon' },
            react_1.default.createElement(_ui_1.Icon, { ico: ico, size: _ui_1.Icon.SIZES.SMALL }))),
        loading && (react_1.default.createElement("div", { className: 'spinner' },
            react_1.default.createElement("div", { className: 'spinning' },
                react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.loader, size: _ui_1.Icon.SIZES.SMALL })))),
        label || children));
};
exports.Button = Button;
Button.SIZES = SIZES;
Button.COLORS = COLORS;
Button.STYLES = STYLES;
Button.HTML_TYPES = HTML_TYPES;
